import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { alpha, Box, FormControl, FormHelperText, inputBaseClasses, styled, TextField } from '@mui/material';
var StyledFormControl = styled(FormControl)(function (_ref) {
  var fullWidth = _ref.fullWidth;
  var styles = {
    display: fullWidth && 'flex',
    maxWidth: '100%'
  };
  return styles;
});
var StyledInputBase = styled(TextField)(function (_ref2) {
  var theme = _ref2.theme,
    color = _ref2.color,
    size = _ref2.size;
  var styles = {
    '& .MuiFormLabel-root': {
      color: theme.palette.jumbo.main,
      '&.MuiInputLabel-shrink': {
        left: theme.typography.pxToRem(2)
      },
      '&.Mui-error': {
        color: theme.palette.guardsmanRed.main
      }
    },
    '& .MuiInputBase-root': _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
      borderRadius: theme.typography.pxToRem(12),
      transition: theme.transitions.create(['border-color'])
    }, "& .".concat(inputBaseClasses.input), {
      boxSizing: 'border-box',
      fontSize: theme.typography.pxToRem(18),
      lineHeight: 'normal',
      fontWeight: 400,
      color: theme.palette.mercury.main,
      position: 'relative',
      height: theme.typography.pxToRem(52),
      padding: theme.spacing(2)
    }), "& .".concat(inputBaseClasses.input, ":-webkit-autofill"), {
      '-webkit-text-fill-color': "".concat(theme.palette.mercury.main, " !important"),
      '-webkit-background-clip': 'text !important',
      'background-clip': 'text !important'
    }), "& .".concat(inputBaseClasses.input, ":-internal-autofill-selected"), {
      '-webkit-text-fill-color': "".concat(theme.palette.mercury.main, " !important"),
      '-webkit-background-clip': 'text !important',
      'background-clip': 'text !important'
    }), "& .".concat(inputBaseClasses.input, " ~ fieldset"), {
      backgroundColor: 'transparent',
      borderWidth: theme.typography.pxToRem(2),
      borderColor: alpha(theme.palette.white.main, 0.08),
      padding: theme.spacing(0, 1.25)
    }), "& .".concat(inputBaseClasses.input, ":hover ~ fieldset"), {
      borderColor: alpha(theme.palette.white.main, 0.03),
      backgroundColor: alpha(theme.palette.white.main, 0.03)
    }), "& .".concat(inputBaseClasses.input, ":focus ~ fieldset"), {
      backgroundColor: 'transparent',
      borderColor: alpha(theme.palette.white.main, 0.08),
      outline: 'none'
    }), "&.Mui-error .".concat(inputBaseClasses.input, " ~ fieldset"), {
      borderColor: theme.palette.guardsmanRed.main
    }), '& > input::placeholder', {
      color: theme.palette.silverChalice.main,
      opacity: 1
    })
  };
  switch (size) {
    case 'large':
      {
        styles = _objectSpread(_objectSpread({}, styles), _defineProperty({}, "& .".concat(inputBaseClasses.input), _objectSpread(_objectSpread({}, styles["& .".concat(inputBaseClasses.input)]), {}, {
          height: theme.typography.pxToRem(46),
          padding: theme.spacing(1.25, 2)
        })));
        break;
      }
    case 'medium':
      {
        styles = _objectSpread(_objectSpread({}, styles), _defineProperty({}, "& .".concat(inputBaseClasses.input), _objectSpread(_objectSpread({}, styles["& .".concat(inputBaseClasses.input)]), {}, {
          height: theme.typography.pxToRem(48),
          padding: theme.spacing(1.5, 1.375)
        })));
        break;
      }
    case 'small':
      {
        styles = _objectSpread(_objectSpread({}, styles), _defineProperty({}, "& .".concat(inputBaseClasses.input), _objectSpread(_objectSpread({}, styles["& .".concat(inputBaseClasses.input)]), {}, {
          height: theme.typography.pxToRem(38),
          padding: theme.spacing(1.25, 1.375),
          fontSize: theme.typography.pxToRem(14),
          lineHeight: theme.typography.pxToRem(18)
        })));
        break;
      }
  }
  return styles;
});
var StyleFormHelperWrapper = styled(Box)(function (_ref3) {
  var theme = _ref3.theme;
  var styles = {
    position: 'absolute',
    left: 0,
    right: 0,
    top: '100%',
    zIndex: 1,
    marginTop: theme.typography.pxToRem(0)
  };
  return styles;
});
var StyledFormHelperErrorText = styled(FormHelperText)(function (_ref4) {
  var theme = _ref4.theme;
  var styles = {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.guardsmanRed.main,
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: theme.typography.pxToRem(18),
    padding: theme.spacing(0, 0, 0, 2),
    margin: 'unset',
    maxWidth: '100%',
    '&.Mui-error': {
      color: theme.palette.guardsmanRed.main
    }
  };
  return styles;
});
var StyledFormHelperWarningText = styled(FormHelperText)(function (_ref5) {
  var theme = _ref5.theme;
  var styles = {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.mirage.main,
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: theme.typography.pxToRem(18),
    padding: theme.spacing(0, 0, 0, 2),
    margin: 'unset',
    maxWidth: '100%'
  };
  return styles;
});
var StyledFormHelperSuccessText = styled(FormHelperText)(function (_ref6) {
  var theme = _ref6.theme;
  var styles = {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.mirage.main,
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: theme.typography.pxToRem(18),
    padding: theme.spacing(0, 0, 0, 2),
    margin: 'unset',
    maxWidth: '100%'
  };
  return styles;
});
var StyledFormHelperText = styled(FormHelperText)(function (_ref7) {
  var theme = _ref7.theme;
  var styles = {
    display: 'block',
    padding: theme.spacing(0),
    margin: 'unset',
    maxWidth: '100%',
    color: theme.palette.mirage.main,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: theme.typography.pxToRem(18)
  };
  return styles;
});
export { StyledFormControl, StyledFormHelperErrorText, StyledFormHelperSuccessText, StyledFormHelperText, StyledFormHelperWarningText, StyledInputBase, StyleFormHelperWrapper };